import { maxLength } from 'vuelidate/lib/validators'
export const validateData = {
  formConfig: {
    clienteName: { maxLength: maxLength(30) },
  },
}

export const validateComputed = {
  clienteNameErrors() {
    const errors = []
    if (!this.$v.formConfig.clienteName.$dirty) return errors
    !this.$v.formConfig.clienteName.maxLength && errors.push('Nome do servidor não pode conter mais de 30 caracteres.')
    return errors
  },
}
